import { useQuery } from "@tanstack/react-query";
import { fetchMaterialOptions } from "../api/fetchMaterialOptions";

export const useMaterialOptions = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["materialOptions"],
    queryFn: fetchMaterialOptions,
  });

  return {
    data: data?.result || [],
    error,
    isLoading,
    refetch,
  };
};

